var Queensland = "Квинсленд";
var Tasmania = "Тасмания";
var Victoria = "Виктория";
var AUStates = {
	"Australian Capital Territory": "Австралийская столичная территория",
	"New South Wales": "Новый Южный Уэльс",
	"Northern Territory": "Северная территория",
	Queensland: Queensland,
	"South Australia": "Южная Австралия",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Западная Австралия"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
